export default __webpack_public_path__ + "static/media/blackTick.db0def74.svg";